import { ref, computed } from 'vue'

export const isMobile = ref(window.innerWidth <= 768)

export const collapsed = ref(isMobile.value)

export const sidebarWidth = computed(() => {
    if (isMobile.value) {
        return '0'
    }

    return collapsed.value ? '60px' : '250px'
})

export const toggleSidebar = () => {
    collapsed.value = !collapsed.value
}

window.addEventListener('resize', () => {
    const mobile = window.innerWidth <= 768
    isMobile.value = mobile
    if (mobile) {
        collapsed.value = true
    } else {
        collapsed.value = false
    }
})